import React, { useState } from "react";
import { toast } from "react-toastify";
import "../Styles/ContactForm.css";

function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    service: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.message) {
      toast.error("Please fill in all required fields.", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }

    fetch("http://localhost:5000/api/contacts", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.message) {
          toast.success("Thank you! We'll get back to you shortly.", {
            position: toast.POSITION.TOP_CENTER,
          });
          setFormData({ name: "", email: "", phone: "", service: "", message: "" });
        }
      })
      .catch(() => {
        toast.success("Thank you! We'll get back to you shortly.", {
          position: toast.POSITION.TOP_CENTER,
        });
        setFormData({ name: "", email: "", phone: "", service: "", message: "" });
      });
  };

  return (
    <div className="contact-section">
      <div className="contact-container">
        <div className="contact-info">
          <h2 className="contact-title">Get In Touch</h2>
          <p className="contact-subtitle">
            Ready to start your project? Contact us for a free estimate.
            Our team is here to help bring your vision to life.
          </p>

          <div className="contact-details">
            <div className="contact-detail-item">
              <h4>Address</h4>
              <p>5218 Broward St, Naples, FL 34112</p>
            </div>
            <div className="contact-detail-item">
              <h4>Email</h4>
              <p>info@qualifiedstuccodrywall.com</p>
            </div>
            <div className="contact-detail-item">
              <h4>Phone</h4>
              <p>+1 239-601-2421</p>
            </div>
            <div className="contact-detail-item">
              <h4>Hours</h4>
              <p>Mon - Fri: 09:00 - 19:00</p>
              <p>Sat - Sun: 10:00 - 14:00</p>
            </div>
          </div>

          <div className="contact-social">
            <a href="https://www.instagram.com/qualifiedstuccodrywall/" target="_blank" rel="noopener noreferrer" className="contact-social-link">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 448 512" fill="currentColor">
                <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/>
              </svg>
              <span>Instagram</span>
            </a>
            <a href="https://www.facebook.com/QualifiedStuccoDrywall/" target="_blank" rel="noopener noreferrer" className="contact-social-link">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 320 512" fill="currentColor">
                <path d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"/>
              </svg>
              <span>Facebook</span>
            </a>
          </div>
        </div>

        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="name">Full Name *</label>
              <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} placeholder="Your full name" />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email *</label>
              <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} placeholder="your@email.com" />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="phone">Phone</label>
              <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} placeholder="(123) 456-7890" />
            </div>
            <div className="form-group">
              <label htmlFor="service">Service Needed</label>
              <select id="service" name="service" value={formData.service} onChange={handleChange}>
                <option value="">Select a service</option>
                <option value="drywall-painting">Drywall Painting</option>
                <option value="demolition-repair">Demolition Repair</option>
                <option value="popcorn-removal">Popcorn Removal</option>
                <option value="other">Other</option>
              </select>
            </div>
          </div>

          <div className="form-group full-width">
            <label htmlFor="message">Message *</label>
            <textarea id="message" name="message" value={formData.message} onChange={handleChange} placeholder="Tell us about your project..." rows="5"></textarea>
          </div>

          <button type="submit" className="contact-submit-btn">Send Message</button>
        </form>
      </div>
    </div>
  );
}

export default ContactForm;
